import type { CuratedStory, Image } from "~types/types";
import {
    type IntegrityStatus,
    firstItemOnly,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface HeroBusinessweekWhiteIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
}

export default function integrityCheck({
    items = [],
    image,
}: HeroBusinessweekWhiteIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly(items), [
        "byline",
        "headline",
    ]);

    if (!image?.baseUrl && !(items?.length && items[0].image?.baseUrl)) {
        messages.push("Missing 'baseUrl' on 'imageToUse'");
    }

    return messages;
}
